/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".candidacy-card[_ngcontent-%COMP%]{margin:0}.candidacy-card[_ngcontent-%COMP%]:hover{cursor:pointer;background:#eaf4fd}.candidacy-card[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .broker[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{margin-left:10px 12px}"];
export { styles as styles };
